function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLikeInactiveIcon = function SvgLikeInactiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.394 130.394",
    width: 22.5,
    height: 22.5,
    style: {
      enableBackground: "new 0 0 130.394 130.394"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#fe9800",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    d: "m117.247 66.326-49.04 49.01-.59.59a3.38 3.38 0 0 1-4.78 0l-49.62-49.6c-12.1-12.08-12.1-31.69 0-43.77 12.1-12.09 31.71-12.09 43.8 0 3.28 3.28 5.44 7.32 5.44 7.32.86 1.61 1.44 3.04 1.83 4.14.49 1.69.91 2.09 1.22 2.09.92 0 .95-3.53 2.88-6.92 1.35-2.38 3.03-4.61 5.06-6.64 12.1-12.09 31.71-12.09 43.8 0 12 12 12.01 31.76 0 43.77v.01z"
  }));
};

export default SvgLikeInactiveIcon;